import React from 'react';
import { MailIcon } from './MailIcon';
import './MailIconWithCount.scss';

export const MailIconWithCount = ({ count }) => {
  return (
    <div className="mail-icon-with-count">
      <div className="mail-icon-with-count__icon">
        <MailIcon />
      </div>
      {count > 0 && (
        <span className="mail-icon-with-count__badge">{count}</span>
      )}
    </div>
  );
};
